import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b09568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["innerHTML"]

import { onMounted, ref } from 'vue';
  import { request } from '@/utils';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const content = ref('');

  const currentRouteName = {
    privacy_policy: t('privacyPolicy'),
    operation_policy: t('operationPolicy'),
    terms_of_use: t('termsOfUse'),
    service_terms_and_conditions: t('locationBased'),
  }[route.params.slug as string] || '';

  onMounted(async () => {
    const { data } = await request.get(`/pages/${route.params.slug}`);
    content.value = data.content;
  });


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      class: "page-breadcurmb",
      routes: [
        {
          name: _unref(t)('Home'),
          to: '/'
        },
        {
          name: _unref(currentRouteName),
        }
      ]
    }, null, 8, ["routes"]),
    _createElementVNode("div", {
      class: "richText",
      innerHTML: content.value
    }, null, 8, _hoisted_2)
  ]))
}
}

})